/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { blankEnumSchema } from "./blankEnumSchema.ts";
import { nullEnumSchema } from "./nullEnumSchema.ts";
import { providerNameEnumSchema } from "./providerNameEnumSchema.ts";

export const smsReportSchema = z.object({
	id: z.uuid(),
	created_at: z.iso.datetime(),
	external_id: z.string().nullish(),
	provider_name: z.union([providerNameEnumSchema, blankEnumSchema, nullEnumSchema]).nullish(),
	sender_type_sms: z.string().nullish(),
	status: z.string().max(100).nullish(),
	status_code: z.int().min(-2147483648).max(2147483647).nullish(),
	sms: z.any().optional(),
	cost_sms: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.nullish(),
	balance: z.number().nullish(),
	organization: z.uuid(),
	provider: z.uuid().nullish(),
});
